// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as ExperimentMenu from "@sothebys/a-binks-feature-testing/src/ExperimentMenu.bs.js";
import * as Config$LiveRoom from "../../Config.bs.js";
import * as ExperimentStore from "@sothebys/a-binks-feature-testing/src/ExperimentStore.bs.js";
import * as Experiment_Utils from "@sothebys/a-binks-feature-testing/src/Experiment_Utils.bs.js";

function keyToJs(param) {
  return param;
}

var LocalStorage = Experiment_Utils.MakeLocalStorage({
      keyToJs: keyToJs,
      keys: {
        hd: "ABT",
        tl: /* [] */0
      }
    });

function getUserIdentifier(param) {
  return "";
}

function analyticsIdentifyUser(param) {
  
}

function sessionStorageSet(experiments) {
  Curry._2(LocalStorage.setItem, "ABT", JSON.stringify(experiments));
}

function sessionStorageGet(param) {
  return Curry._1(LocalStorage.getItem, "ABT");
}

var ExperimentStoreModule = ExperimentStore.MakeExperimentStore({
      getUserIdentifier: getUserIdentifier,
      analyticsIdentifyUser: analyticsIdentifyUser,
      sessionStorageSet: sessionStorageSet,
      sessionStorageGet: sessionStorageGet
    });

var _map = {"Off":"Off","On":"On"};

function groupToJs(param) {
  return param;
}

function groupFromJs(param) {
  return _map[param];
}

var IdRestriction = ExperimentStore.MakeExperiment({
      name: "Id restriction enabled",
      groupToJs: groupToJs,
      groupFromJs: groupFromJs,
      groupDistribution: {
        hd: [
          "Off",
          100
        ],
        tl: {
          hd: [
            "On",
            0
          ],
          tl: /* [] */0
        }
      },
      type_: "Query",
      status: "WorkInProgress",
      ExperimentStore: {
        init: ExperimentStoreModule.init,
        getExperimentGroup: ExperimentStoreModule.getExperimentGroup,
        selectExperiment: ExperimentStoreModule.selectExperiment,
        addExperiment: ExperimentStoreModule.addExperiment,
        getExperiments: ExperimentStoreModule.getExperiments
      }
    });

var ExperimentMenuComponent = ExperimentMenu.MakeExperimentMenu({
      init: ExperimentStoreModule.init,
      getExperimentGroup: ExperimentStoreModule.getExperimentGroup,
      selectExperiment: ExperimentStoreModule.selectExperiment,
      addExperiment: ExperimentStoreModule.addExperiment,
      getExperiments: ExperimentStoreModule.getExperiments
    });

function FeatureFlagStore$Provider(props) {
  React.useEffect((function () {
          Curry._1(ExperimentStoreModule.init, undefined);
        }), []);
  return React.createElement(React.Fragment, undefined, props.children, Config$LiveRoom.tier === "Prod" ? null : React.createElement(ExperimentMenuComponent.make, {}));
}

var Provider = {
  make: FeatureFlagStore$Provider
};

export {
  LocalStorage ,
  ExperimentStoreModule ,
  IdRestriction ,
  ExperimentMenuComponent ,
  Provider ,
}
/* LocalStorage Not a pure module */
